export default interface IApplicationBasic {
  id: string;
  name: string;
  displayName: string;
  status: number;
  originApplication: string;
  createdAt: string;
}

export interface IPreActivationStep {
  marked: boolean;
  last_modified_at: Date;
  last_modified_by: string;
  comment: string;
}

export interface IFinancingApplication extends IApplicationBasic {
  preActivationSteps: Record<string, IPreActivationStep>;
}

export enum ApplicationStatementType {
  MajorityShareHolder = 'majority_share_holder',
  LaonsTermination = 'laons_termination',
}

export enum MajorityShareHolderValue {
  ShareHolder = 0,
  RegisteredUser = 1,
}

export enum LoansTerminationValue {
  OnDueDate = 0,
  AfterDueDate = 1,
}
